import { EnumFileCartellaDtoTipo } from '@framework/api-client/api/inquiries-compile/schemas/enumFileCartellaDtoTipo.ts';
import { Tag } from 'antd';
import { useTranslation } from 'react-i18next';
import { type IPublicAreaFile } from './getTableTreeDataFromCartelle.tsx';

export interface IPublicFileTypeTagProps {
  record: IPublicAreaFile;
}

export function PublicFileTypeTag(props: IPublicFileTypeTagProps) {
  const { t } = useTranslation();

  switch (props.record.tipo) {
    case EnumFileCartellaDtoTipo.ALLEGATI_RICHIESTA:
      return (
        <Tag color="blue">
          {t(
            'observation-details.allegato-della-richiesta',
            'Allegato della Richiesta',
          )}
        </Tag>
      );
    case EnumFileCartellaDtoTipo.COMUNICAZIONE:
      return (
        <Tag color="green">
          {t('observation-details.comunicazione', 'Comunicazione')}
        </Tag>
      );
    case EnumFileCartellaDtoTipo.DOCUMENTO:
      return (
        <Tag color="purple">
          {t('observation-details.documento', 'Documento')}
        </Tag>
      );
    case EnumFileCartellaDtoTipo.GRUPPO_ALLEGATO:
      return (
        <Tag color="orange">
          {t(
            'observation-details.allegato-del-procedimento',
            'Allegato del Procedimento',
          )}
        </Tag>
      );
  }
}
